import "@babylonjs/loaders/glTF/2.0/index";
import "@babylonjs/core/Animations/animatable";
import { Scene } from "@babylonjs/core/scene";
import { Mesh } from "@babylonjs/core/Meshes/mesh";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { AbstractMesh } from "@babylonjs/core/Meshes/abstractMesh";
import { BoundingInfo } from "@babylonjs/core/Culling/boundingInfo";
import { SceneLoader, ISceneLoaderAsyncResult } from "@babylonjs/core/Loading/sceneLoader";
import Constants from "common/constant";

export const loadMesh = (
  scene: Scene,
  name: string,
  initialPosition?: Vector3,
): Promise<AbstractMesh> => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const handleImportMesh = (result: ISceneLoaderAsyncResult) => {
      const mesh = result.meshes[0];
      const boundingInfo = mesh.getHierarchyBoundingVectors();
      mesh.setBoundingInfo(new BoundingInfo(boundingInfo.min, boundingInfo.max));

      for (let i = 0; i < result.meshes.length; i++) {
        const subMesh = result.meshes[i];
        if (subMesh.material) {
          // @ts-expect-error Babylon.js Material の型に無いプロパティ
          subMesh.material.specularIntensity = 0.3;
        }
      }

      if (initialPosition) {
        mesh.position = initialPosition;
      }

      resolve(mesh);
    };

    SceneLoader.ImportMeshAsync("", `${Constants.assetHost}/assets/models/`, name, scene)
      .then((result) => {
        handleImportMesh(result);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const copyMesh = (mesh: Mesh, name: string, initialPosition?: Vector3) => {
  const newMesh = mesh.clone(name);

  newMesh.position = new Vector3(0, 0, 0);
  const boundingInfo = newMesh.getHierarchyBoundingVectors();
  newMesh.setBoundingInfo(new BoundingInfo(boundingInfo.min, boundingInfo.max));

  if (initialPosition) {
    newMesh.position = initialPosition;
  }

  return newMesh;
};
